import {Box, Flex, Heading, Icon, IconButton, Text} from "@chakra-ui/react";
import {FiEdit, FiGlobe, FiLock} from "react-icons/fi";
import {useNavigate} from "react-router-dom";
import {ListResponse} from "../services/responses";
import {useUIManager} from "../hooks/useUIManager";

interface ListCardProps {
  list: ListResponse;
  username: string;
  editable: boolean;
}

const VISIBILITY_ICON = {
  private: FiLock,
  link: FiGlobe,
  public: undefined,
} as const;

export const ListCard = ({list, username, editable}: ListCardProps) => {
  const navigate = useNavigate();
  const uiManager = useUIManager();
  const icon = VISIBILITY_ICON[list.visibility];

  const onEdit = (event: React.MouseEvent) => {
    event.stopPropagation();
    uiManager.toggleListModal(true, list.uuid);
  };

  return <Box
    bg="white"
    w="100%"
    maxW={{base: "100%", sm: "100%", md: "49%"}}
    p={4}
    borderRadius="lg"
    position="relative"
    cursor="pointer"
    _hover={{boxShadow: "md"}}
    onClick={() => navigate(`/${username}/${list.uuid}`)}
  >
    {editable && (
      <IconButton
        position="absolute"
        top="0.75rem"
        right="0.75rem"
        size="xs"
        variant="ghost"
        aria-label="Edit list"
        icon={<FiEdit/>}
        onClick={onEdit}
      />
    )}
    <Flex alignItems="center" gap={2} pe={editable ? 8 : 0}>
      {icon && <Icon as={icon} color="gray.500" aria-label={list.visibility}/>}
      <Heading as="h3" size="sm" noOfLines={1}>{list.name}</Heading>
    </Flex>
    {list.description && (
      <Text fontSize={{base: "xs", sm: "sm"}} color="gray.600" mt={2} noOfLines={2}>{list.description}</Text>
    )}
  </Box>;
};
